import React, { useCallback } from 'react';
import { TbTrash } from 'react-icons/tb';
import { useDeleteCommentInThread, useDeleteThread } from '../../../../../services/comment.service';

interface CommentDeleteButtonProps {
  threadID: string;
  commentID: string;
  threadCommentsCount: number;
  refetchComments: () => Promise<unknown>;
}

const CommentDeleteButton = ({
  threadID,
  commentID,
  threadCommentsCount,
  refetchComments
}: CommentDeleteButtonProps) => {
  const deleteThreadMutation = useDeleteThread();
  const deleteCommentMutation = useDeleteCommentInThread();

  const handleSuccessAfterDelete = useCallback(() => {
    refetchComments();
  }, [refetchComments]);

  const handleDeleteComment = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();

    if (!commentID || threadCommentsCount <= 1) {
      deleteThreadMutation.mutate(
        { threadID },
        {
          onSuccess: handleSuccessAfterDelete
        }
      );
    } else {
      deleteCommentMutation.mutate(
        { threadID, commentID },
        {
          onSuccess: handleSuccessAfterDelete
        }
      );
    }
  };

  return (
    <button
      id={`comment-delete-button-${commentID}`}
      onClick={handleDeleteComment}
      data-testid={`delete-button-${commentID}`}
    >
      <TbTrash color="#868e96" />
    </button>
  );
};

export default CommentDeleteButton;
